import React, { useState, useEffect } from 'react';
import { TextField, FormControlLabel, Checkbox } from '@mui/material';
import { useSelector } from 'react-redux';
import TEXT from './text';

const NameFieldComponent = ({ properties, value, valueUpdaterCallback, validityUpdaterCallback }) => {
    const language = useSelector(state => state.App_Settings.language);
    const { options = {}, constrains = {} } = properties;

    const [inputValue, setInputValue] = useState(value || options.value || '');

    // Sync with parent value changes
    useEffect(() => {
        if (value !== undefined && value !== inputValue) {
            setInputValue(value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const handleChange = (event) => {
        const newValue = event.target.value;

        // Check constraints
        if (constrains.maxLength && newValue.length > constrains.maxLength) {
            return;
        }

        if (constrains.pattern && !new RegExp(constrains.pattern).test(newValue)) {
            return;
        }

        setInputValue(newValue);

        // Notify parent component
        if (valueUpdaterCallback) {
            valueUpdaterCallback(newValue);
        }

        // Update validity
        if (validityUpdaterCallback) {
            const isValid = options.required ? newValue.trim() !== '' : true;
            validityUpdaterCallback(isValid);
        }

        if (options.onChange) {
            options.onChange(newValue);
        }
    };

    return (
        <TextField
            label={options.label || TEXT.NameField[language]}
            variant={options.variant || 'outlined'}
            value={inputValue}
            onChange={handleChange}
            placeholder={options.placeholder || ''}
            fullWidth={options.fullWidth !== false}
            required={options.required || false}
            inputProps={{
                maxLength: constrains.maxLength || undefined,
                pattern: constrains.pattern || undefined,
            }}
            sx={{ width: '100%', maxWidth: '100%' }}
        />
    );
};

const NameFieldOptions = ({ options, setOption, KeepItSimple }) => {
    return (
        <div>
            <h4>Options</h4>
            {Object.entries(options).map(([key, value]) => (
                <FormControlLabel
                    key={key}
                    control={<Checkbox checked={value} onChange={() => setOption(key, !value)} />}
                    label={key}
                />
            ))}
            {KeepItSimple && <p>Keep it simple mode is enabled.</p>}
        </div>
    );
};

const NameFieldConstrains = ({ constrains, setConstrains, options, KeepItSimple }) => {
    return (
        <div>
            <h4>Constrains</h4>
{!KeepItSimple &&
            <ul>
                {Object.entries(constrains).map(([key, value]) => (
                    <li key={key}>
                        <strong>{key}:</strong> {value}
                        {setConstrains && (
                            <button onClick={() => setConstrains(key, value)}>Edit</button>
                        )}
                    </li>
                ))}
            </ul>
}

            {KeepItSimple && <p>Keep it simple mode is enabled.</p>}
        </div>
    );
};

export { NameFieldComponent, NameFieldOptions, NameFieldConstrains };
